export class AbstractController {
    get data() {
        return this._data;
    }
    set data(data) {
        this._data = data;
        this.updateData(data);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateData(_data) {
        if (this.host.isConnected) {
            this.host.requestUpdate();
        }
    }
    constructor(host, component) {
        this._data = [];
        (this.host = host).addController(this);
        this.el = component;
    }
    clear() {
        this.data = [];
    }
    destroy() {
        this.host.removeController(this);
    }
}
//# sourceMappingURL=abstract-controller.js.map